import { getId, getUniqueCount, isEffectivelyNumeric, } from '@thoughtspot/visualization-column-util';
import _ from 'lodash';
import { getDataRowIndex } from '../core/axis-config-util';
import { getAttributeColumns, getChartType, getTimeSeriesColumns, } from '../core/chart-model-utils';
import { chartProviders, getChartProvider, } from '../core/chart-type-specification-service';
import { PivotDataModel } from '../devextreme/model/pivot-data-model';
import { HighchartDataModel } from '../highcharts/highchart-data-model';
import { InsightChartDataModel } from '../insights/insight-data-model';
import { NetworkChartDataModel } from '../network-map/network-chart-data-model';
import { ReactChartDataModel } from '../reactcharts/react-chart-data-model';
import { createLogger } from '../utils/logger';
import { VarianceCalculator } from './blink-statistics-library';
export function computeMetaDataInformation(chartModel, dataModel) {
    createLogger('chart-data-processor');
    const data = dataModel.getDataArray()[0].getData();
    const colCardinality = {};
    const timeSeriesColumns = getTimeSeriesColumns(chartModel);
    const chartedAsAttributeColumns = _.difference(getAttributeColumns(chartModel), timeSeriesColumns);
    _.each(chartedAsAttributeColumns, function (col) {
        const colId = getId(col);
        colCardinality[colId] = getUniqueCount(col) || -1;
    });
    if (dataModel.hasNoData) {
        return {
            colCardinality,
        };
    }
    const definition = chartModel;
    const measureColumns = [];
    const attributeColumns = [];
    let dataRowIndex = 0;
    [].forEach(function (bucket) {
        if (!bucket || !bucket.columns || !bucket.columns.length) {
            return;
        }
        bucket.columns.forEach(columnJson => {
            if (!columnJson || !Object.keys(columnJson).length) {
                return;
            }
            const idx = dataRowIndex++;
            const column = { ...columnJson, dataRowIndex: idx };
            if (isEffectivelyNumeric(column)) {
                measureColumns.push(column);
            }
            else {
                attributeColumns.push(column);
            }
        });
    });
    const columnIdToMin = {};
    const columnIdToMax = {};
    const columnIdToUniques = {};
    const dataRowIndexToAttributeColId = {};
    const dataRowIndexToMeasureColId = {};
    const measureColIdToVarianceCalculator = {};
    attributeColumns.forEach(col => {
        const colId = getId(col);
        dataRowIndexToAttributeColId[getDataRowIndex(col)] = colId;
        columnIdToUniques[colId] = {};
    });
    measureColumns.forEach(col => {
        const colId = getId(col);
        columnIdToUniques[colId] = {};
        columnIdToMin[colId] = Number.POSITIVE_INFINITY;
        columnIdToMax[colId] = Number.NEGATIVE_INFINITY;
        dataRowIndexToMeasureColId[getDataRowIndex(col)] = colId;
        measureColIdToVarianceCalculator[colId] = new VarianceCalculator();
    });
    const attributeDataRowIndices = Object.keys(dataRowIndexToAttributeColId);
    const measureDataRowIndices = Object.keys(dataRowIndexToMeasureColId);
    const chartData = dataModel.getDataArray()[0].getData();
    let i = chartData.length;
    while (i--) {
        const dataRow = chartData[i];
        const dataRowLength = dataRow.length;
        let value;
        let colId;
        let colUniques;
        let j = attributeDataRowIndices.length;
        while (j--) {
            dataRowIndex = Number(attributeDataRowIndices[j]);
            if (dataRowIndex < dataRowLength) {
                value = dataRow[dataRowIndex];
                colId = dataRowIndexToAttributeColId[dataRowIndex];
                colUniques = columnIdToUniques[colId];
                if (!colUniques.hasOwnProperty(value)) {
                    colUniques[value] = 1;
                }
            }
        }
        j = measureDataRowIndices.length;
        while (j--) {
            dataRowIndex = Number(measureDataRowIndices[j]);
            if (dataRowIndex < dataRowLength) {
                value = dataRow[dataRowIndex];
                if (!_.isNaN(Number(value))) {
                    colId = dataRowIndexToMeasureColId[dataRowIndex];
                    columnIdToMin[colId] = Math.min(value, columnIdToMin[colId]);
                    columnIdToMax[colId] = Math.max(value, columnIdToMax[colId]);
                    measureColIdToVarianceCalculator[colId].add(value);
                }
                colUniques = columnIdToUniques[colId];
                if (colUniques && !colUniques.hasOwnProperty(value)) {
                    colUniques[value] = 1;
                }
            }
        }
    }
    return {
        columnIdToMin,
        columnIdToMax,
        columnIdToUniques,
        colCardinality,
        dataRowIndexToAttributeColId,
        dataRowIndexToMeasureColId,
    };
}
function getChartProviderToDataModel() {
    return {
        [chartProviders.HIGHCHART]: HighchartDataModel,
        [chartProviders.GEO_MAP]: HighchartDataModel,
        [chartProviders.GEO_EARTH]: HighchartDataModel,
        [chartProviders.PIVOT_TABLE]: PivotDataModel,
        [chartProviders.NETWORK]: NetworkChartDataModel,
        [chartProviders.REACT_COMPONENT]: ReactChartDataModel,
        [chartProviders.INSIGHT]: InsightChartDataModel,
    };
}
export function processDataModel(chartModel, data, queryDefinitions, envOptions, chartOptions, getEventMap) {
    const chartType = getChartType(chartModel);
    const chartProvider = getChartProvider(chartType, !!chartModel.cortexData);
    const chartProviderToDataModel = getChartProviderToDataModel();
    return new chartProviderToDataModel[chartProvider](chartModel, data, queryDefinitions, envOptions, chartOptions, getEventMap);
}
//# sourceMappingURL=chart-data-processor-service.js.map